import React from 'react';
import PropTypes from 'prop-types';
import Lock from '@alefeducation/ui-elements-library-icons/lib/components/Icons/Lock';
import Plus from '@alefeducation/ui-elements-library-icons/lib/components/Icons/Plus';
import UserPlus from '@alefeducation/ui-elements-library-icons/lib/components/Icons/UserPlus';
import './styles/ncle-icons.scss';

export const ActivityAssignPlusIcon = ({ size = 20 }) => {
  const plusFontSize = size === 28 ? 12 : 8;

  return (
    <span
      className="ncle-assign-plus-icon"
      style={size === 28 ? { width: 28, height: 28 } : undefined}
      aria-hidden
    >
      <Plus fontSize={plusFontSize} color="#485465" />
    </span>
  );
};

ActivityAssignPlusIcon.propTypes = {
  size: PropTypes.number,
};

ActivityAssignPlusIcon.defaultProps = {
  size: 20,
};

export const renderAssignIcon = isNCLE =>
  isNCLE ? <ActivityAssignPlusIcon size={20} /> : <Lock fontSize={18} />;

export const renderAssignAllIcon = isNCLE =>
  isNCLE ? <UserPlus fontSize={18} /> : <Lock fontSize={18} />;
